export default __webpack_public_path__ + "static/media/s.fed00bb8.png";